import React, { useState } from 'react'
import MaterialTable from '@material-table/core'
import HeaderComponent from 'components/HeaderComponent'
// import Icons from 'includes/Icons'
import { withTranslation } from 'react-i18next'
import { UilPlus } from '@iconscout/react-unicons'
import Paginator from 'components/Paginator'
import useSWR, { mutate } from 'swr'
import PreviewCampaign from './PromoCardDetails/components/Campaigns/PreviewCampaign'
import images from 'assets/img'
import Btn from 'components/Btn'
import { apiRequest } from 'store/Misc/apiRequest'
import { Typography } from '@mui/material'
import CurrencyFormat from 'react-currency-format'
import usePermissions from 'hooks/usePermissions'
import { toast } from 'react-toastify'
import Spinner from 'components/Spinner'
import { withRouter } from 'hooks/withRouter'

export default withTranslation()(withRouter(function CampaignTable({ t, router: { navigate }, hideHeader = false }) {
  const [pageNumber, setPageNumber] = useState(1)
  const { data: campaigns } = useSWR(`promos/campaigns?page=${pageNumber}&page-size=10`)
  const [preview, setPreview] = useState(null)

  const change = (pageNumber) => setPageNumber(pageNumber)
  const close = () => setPreview(null)
  const { isPermitted } = usePermissions()
  const pausePromo = async (id) => {
    try {
      await apiRequest({
        method: 'get',
        url: `promos/campaigns/${id}/pause`
      })

      mutate(`promos/campaigns?page=${pageNumber}&page-size=10`)
    } catch (error) {

    }
  }
  const deletePromo = async (id) => {
    // alert(id)
    try {
      await apiRequest({
        method: 'delete',
        url: `promos/campaigns/${id}`
      })
      // console.log(res)
      toast.success('campaign deleted successfully')

      // mutate(`promos/campaigns?page=${pageNumber}&page-size=10`)
    } catch (error) {

    }
  }

  const cellStyle = {
    fontFamily: 'Helvetica',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '21px',
    color: '#05213D'
  }

  return (
    <div className="w-full">

      <MaterialTable
        columns={[
          {
            title: t('promo.title'),
            field: 'title',
            render: ({ title }) => {
              return <Typography className='capitalize' sx={{ ...cellStyle }} > {title} </Typography>
            }
          },
          {
            title: t('promo.create.budget'),
            field: 'budget',
            render: ({ budget }) => {
              return <Typography sx={{ ...cellStyle }} > <CurrencyFormat value={budget} displayType={'text'} thousandSeparator={true} prefix={'NGN '} renderText={value => <div>{value}</div>} /> </Typography>
            }
          },
          {
            title: t('promo.form.impression'),
            field: 'impressions',
            render: ({ impressions }) => {
              return <Typography sx={{ ...cellStyle }} > <CurrencyFormat value={impressions} displayType={'text'} thousandSeparator={true} prefix={''} renderText={value => <div>{value}</div>} /> </Typography>
            }
          },
          {
            title: t('promo.views'),
            field: 'views',
            render: ({ views_count }) => {
              return <Typography sx={{ ...cellStyle }} > <CurrencyFormat value={views_count} displayType={'text'} thousandSeparator={true} prefix={''} renderText={value => <div>{value}</div>} /></Typography>
            }
          },
          {
            title: t('promo.type'),
            field: 'type',
            render: ({ type }) => {
              return <Typography sx={{ ...cellStyle }} className='capitalize' > {type} </Typography>
            }
          },
          {
            title: t('misc.status'),
            field: 'status',
            render: ({ status }) => <>
              {console.log('Status from campaigns', status)}
              {
                status.toLocaleLowerCase() === 'active' ? (
                  <span className="bg-green-300 border border-green-300 bg-opacity-40 text-success p-1 inline-block text-center w-[70px] rounded-md">{`${status.charAt(0).toUpperCase()}${status.slice(1)}`}</span>
                ) : (
                  <>
                    {
                      status.toLocaleLowerCase() === 'pending' ? (
                        <span className="bg-yellow-300 bg-opacity-40 text-yellow-600 border border-yellow-600 p-1 inline-block text-center w-[70px] rounded-md">{`${status.charAt(0).toUpperCase()}${status.slice(1)}`}</span>
                      ) : (
                        <span className="bg-red-300 border border-red-300 bg-opacity-40 text-danger p-1 inline-block text-center w-[70px] rounded-md">{`${status.charAt(0).toUpperCase()}${status.slice(1)}`}</span>
                      )
                    }
                  </>

                )
              }
            </>
          },
        ]}
        isLoading={campaigns?.isValidating}
        actions={[
          {
            // icon: 'save',
            tooltip: 'Save User',
          },
        ]}
        options={{
          actionsColumnIndex: -1,
          headerStyle: {
            // fontFamily: "open sans",
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "16px",
            lineHeight: "150%",
            color: "#657585"
          },
          rowStyle: {
            // backgroundColor:'red'
            cursor: 'pointer',
            '&:hover': { backgroundColor: 'red' }
          },
        }}
        // icons={Icons}
        data={campaigns?.data.data ?? []}
        localization={{
          body: {
            emptyDataSourceMessage: campaigns?.data.data?.length === 0 ? 'No record to display' : <Spinner />
          }
        }}
        components={{
          Toolbar: props => (
            <>
              {
                hideHeader ? null : (
                  <div className="border-b pb-5 mb-5 ">
                    <HeaderComponent
                      title={t('promo.campaigns')}
                      btnText={() => <><UilPlus size={20} className="mr-2" />{t('promo.add')}</>}
                      btnClick={() => navigate('/promo/campaign/create-campaign')}
                      hideBtn={!isPermitted?.create_campaign}
                    />
                  </div>
                )
              }
            </>
          ),
          Action: ({ data }) => (
            <ul className="opacity-1 flex">
              <li className="">
                <Btn
                  content={() => <images.ChartIcon classList="h-4 w-4" />}
                  className="w-8 h-8 p-0 hover:bg-input"
                  click={() => { window.location.assign(`/promo/campaign/monitoring?id=${data.id}`) }}
                />
              </li>
              <li className="ml-2 mr-1">
                <Btn
                  content={() => <images.EyeIcon classList="h-5 w-5 m-auto" />}
                  className="w-8 h-8 p-0 hover:bg-input flex"
                  click={() => setPreview(data)}
                />

              </li>
              <li className="mr-2 ml-1">
                <Btn
                  content={() => <images.PauseIcon classList="h-4 w-4" />}
                  className="w-8 h-8 p-0 hover:bg-input"
                  click={() => pausePromo(data.id)}
                />

              </li>
              <li className="">
                <Btn
                  content={() => <images.TrashIcon classList="h-4 w-4" />}
                  className="w-8 h-8 p-0 hover:bg-input"
                  click={() => deletePromo(data.id)}
                  disabled={!isPermitted?.delete_branches}
                />

              </li>
            </ul>
          ),
          Pagination: ({ data }) => (
            <>
              <Paginator
                pageChange={change ?? 0}
                misc={{ last: campaigns?.data.last_page, current: campaigns?.data.current }}
              />
            </>
          )
        }}
      />

      {
        preview ? <PreviewCampaign promo={preview} close={close} /> : null
      }

    </div>
  );
}))